import { SchedulingMethod } from "~/common/types/schedulingMethods";
import { api } from "./axios";

export const getSchedulingMethods = async ({
  organizationId,
}: {
  organizationId: string;
}) => {
  const { data } = await api.get<SchedulingMethod>(
    `v1/organizations/${organizationId}/scheduling-methods`,
  );

  return data;
};

export const updateSchedulingMethods = async ({
  organizationId,
  schedulingMethod,
}: {
  organizationId: string;
  schedulingMethod: SchedulingMethod;
}) => {
  await api.put(
    `v1/organizations/${organizationId}/scheduling-methods`,
    schedulingMethod,
  );
};
